import clsx from "clsx";
import styles from "./bankText.module.scss";

const BankText = ({ text, dashed }) => {
  return (
    <div className={clsx(styles.inlineText, "bankText", dashed && styles.dashed)}>
      <p>{text}</p>
    </div>
  );
};

export default BankText;
